// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { UserService } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Service/User';

export const useRejectCollateralAgreementRequest = () => {
  const { submit } = useExerciseSubmission(
    UserService.UserService_RejectCollateralAgreementRequest,
    'Successfully rejected collateral agreement request',
    'Failed to reject collateral agreement',
  );
  return submit;
};
